<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :timeout="timeout"
    :top="true">
    {{ text }}
    <v-btn
      dark
      text
      icon
      @click="snackbar = false">
      <v-icon>
        fas fa-times
      </v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
    name: 'SnackBar',
    data: () => ({
        snackbar: false,
        color: 'success',
        timeout: 3000,
        text: ''
    }),
    created () {
        this.$root.$on('show-snackbar', (event) => {
            this.showSnackbar(event);
        });
        this.$root.$on('close-snackbar', (event) => {
            this.closeSnackbar(event);
        });
    },
    methods: {
        showSnackbar (event) {
            this.$data.snackbar = true;
            this.$data.color = event.color || 'success';
            this.$data.timeout = event.timeout || 3000;
            this.$data.text = event.message;
        },
        closeSnackbar () {
            this.$data.snackbar = false;
        },
    }
};
</script>
